import styled from "styled-components";

export const Wrapper = styled.img``;
